export const cartQueryKeys = {
  all: ['cart'] as const,
  calculate: (cartHash: string, depsHash: string) =>
    ['cart', 'calculate', cartHash, depsHash] as const,
};

/**
 * Serialised calculate dependencies of the cart — the `depsHash` part of
 * {@link cartQueryKeys.calculate}. The membership marker is a separate required
 * argument: a purchase, a cancellation or a plan switch changes the member
 * discount and threshold without touching any other dependency, so a key built
 * without it would never re-price the cart.
 */
export const calculateDepsKey = (
  deps: Record<string, unknown>,
  membershipMarker: string | null,
): string =>
  JSON.stringify({ ...deps, membership: membershipMarker ?? undefined });
